import { Component, OnInit, Input } from '@angular/core';
import { cdnUrl } from 'apps/ihowebsite/src/app/app.module';

@Component({
  selector: 'iho-masonry-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss']
})
export class MasonryItemComponent implements OnInit {
cdnUrl = cdnUrl
  // ---
  @Input() data: any;
  @Input() reviewsCount!: number;
  @Input() isTruncate: boolean =false;
  // ---
  constructor() { }

  ngOnInit(): void {
  }

}
